<template>
    <v-container class="my-5">
        <h2 class="subheading grey--text">{{$t('water_service')}}</h2>
        <v-layout row wrap class="justify-center">
            <v-btn
                    v-if="getProfile.role === 2 && change"
                    color="primary"
                    :loading="loading"
                    @click="createWaterService()"
            >
              <v-icon>mdi-tanker-truck</v-icon>
                {{$t('request_water_pipe')}}
            </v-btn>
            <v-btn
                    v-else-if="getProfile.role === 2 && !change"
                    :disabled="true"
                    color="primary"
                    :loading="loading"
                    @click="createWaterService()"
            >
              <v-icon>mdi-tanker-truck</v-icon>
                {{$t('msg_water_service_request_sent')}}
            </v-btn>
        </v-layout>
        <v-layout class="my-4" align-center justify-center fill-height>
            <v-flex >
                <v-card-title>
                    {{$t('water_service')}}
                    <v-spacer></v-spacer>
                    <v-text-field
                            v-model="search"
                            clearable
                            append-icon="mdi-magnify"
                            :label="$t('Buscar')"
                            single-line
                            hide-details
                    ></v-text-field>
                </v-card-title>
                <v-data-table
                        :headers="headers"
                        :loading="loadingDataDirectory"
                        :items="directorys"
                        :search="search"
                        :footer-props="{
                            itemsPerPageOptions: [
                                {text: '5', value: 5},
                                {text: '10', value: 10},
                                {text: '25', value: 25},
                                {text: this.$t('todos'), value: -1}
                            ],
                            itemsPerPageText: $t('filas_por_pagina')
                        }"
                        :no-data-text="$t('no_records_yet')"
                        class="elevation-1"
                >
                  <template v-slot:item.status="{ item }">
                    <v-chip
                        label
                        :color="item.status === 0 ? 'warning' : 'success'"
                        dark
                    >
                      {{item.status === 0 ? $t('requested') : $t('delivered') }}
                    </v-chip>
                  </template>
                  <template v-slot:item.vigilant_name="{ item }">
                      {{item.vigilant_name === null ? 'n/a' : item.vigilant_name }}
                  </template>
                  <template v-slot:item.resident_name="{ item }">
                      {{item.resident_name === null ? 'n/a' : item.resident_name }}
                  </template>
                  <template v-slot:item.date_time_delivery="{ item }">
                      {{item.date_time_delivery === null ? 'n/a' : item.date_time_delivery }}
                  </template>
                </v-data-table>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
import axios from 'axios'
import store from '@/store'
import { mapGetters, mapState } from 'vuex'

export default {
  name: 'water_service',
  created () {
    this.getWaterServiceDelivered()
    this.getWaterService()
  },
  computed: {
    ...mapState(['language']),
    ...mapGetters(['getProfile'])
  },
  data: () => ({
    dialog: false,
    idHouse: '',
    name: '',
    number: '',
    nameAux: '',
    numberAux: '',
    header: [],
    loadingDataDirectory: false,
    loading: false,
    directorys: [],
    search: '',
    update: false,
    errores: [],
    errorsPhone: [],
    idUpdate: 0,
    idDirectoryDelete: 0,
    deleteDialog: false,
    dialogImageLogo: false,
    file: null,
    change: false,
    rules: [
      value => !value || value.type === 'application/vnd.ms-excel' || 'Archivo con formato incorrecto.'
    ],
    headers: [],
    resultLogoURL: '',
    imageFrontURL: ''
  }),
  beforeUpdate () {
    this.headers = [
      {
        text: this.$t('direccion'),
        align: 'left',
        sortable: true,
        value: 'house_address'
      },
      {
        text: this.$t('estado'),
        align: 'center',
        sortable: true,
        value: 'status'
      },
      {
        text: this.$t('date_time_request'),
        align: 'left',
        sortable: true,
        value: 'date_time_receipt'
      },
      {
        text: this.$t('delivery_date_time'),
        align: 'left',
        sortable: true,
        value: 'date_time_delivery'
      },
      {
        text: this.$t('Vigilante'),
        align: 'left',
        sortable: true,
        value: 'vigilant_name'
      }
    ]
  },
  methods: {
    getWaterService () {
      this.loadingDataDirectory = true
      const config = {
        method: 'get',
        url: 'https://residencial-services.intrare.app/water_service_get_post/',
        headers: {
          'Content-Type': 'application/json',
          'Accept-Language': this.language,
          'authorization': 'Token ' + store.getters.getToken
        }
      }
      axios(config)
        .then(response => {
          this.directorys = response.data
          this.loadingDataDirectory = false
        })
        .catch(error => {
          this.loadingDataDirectory = false
          console.log(error)
        })
    },
    getWaterServiceDelivered () {
      this.loadingDataDirectory = true
      const config = {
        method: 'get',
        url: 'https://residencial-services.intrare.app/water_service_delivered',
        headers: {
          'Content-Type': 'application/json',
          'authorization': 'Token ' + store.getters.getToken
        }
      }
      axios(config)
        .then(response => {
          if (response.status === 204) {
            this.change = true
          } else {
            this.change = false
          }
        })
        .catch(error => {
          this.change = false
          console.log(error)
        })
    },
    createWaterService () {
      this.loading = true
      const config = {
        method: 'post',
        url: 'https://residencial-services.intrare.app/water_service_get_post/',
        headers: {
          'Content-Type': 'application/json',
          'authorization': 'Token ' + store.getters.getToken
        }
      }
      axios(config)
        .then(response => {
          this.loading = false
          this.change = false
          this.getWaterService()
          this.$store.commit('snackbar_activate_true')
          this.$store.commit('snackbar_change_message', this.$t('request_sent_successfully'))
          setTimeout(this.clear, 3000)
        })
        .catch(error => {
          this.loading = false
          console.log(error)
        })
    },
    clear: function () {
      this.$store.commit('snackbar_change_color', 'success')
      this.$store.commit('snackbar_activate_false')
      this.loading = false
    }
  }
}
</script>
